import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	offerSummaryTemplate: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	tripOverviewContainer: {
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		border: theme.divider.border,
		boxShadow: theme.elevation.top.lifted,
		borderRadius: theme.borderRadius.rounded,
		position: 'relative',
	},
	imageContainer: {
		position: 'relative',
		width: '100%',
		height: '178px',

		[getFromBreakpoint('md')]: {
			height: '226px',
		},
	},
	image: {
		borderTopLeftRadius: theme.borderRadius.rounded,
		borderTopRightRadius: theme.borderRadius.rounded,
		objectFit: 'cover',
	},
	overlayContainer: {
		zIndex: theme.zIndex.lifted,
		position: 'absolute',
		bottom: theme.spacing.small,
		left: theme.spacing.small,
	},
	infoContainer: {
		margin: theme.spacing.small,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
	},
	details: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
	},
	accommodationTitleWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
		marginBottom: theme.spacing.xxsmall,

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'start',
		},
	},
	accommodationTitle: {
		padding: 0,
		margin: 0,
	},
	flights: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'space-between',
		borderBottom: theme.divider.border,
		borderTop: theme.divider.border,
		margin: `${theme.spacing.small} 0`,
		[`&> div:last-child`]: {
			borderTop: theme.divider.border,
			paddingTop: theme.spacing.small,
			marginTop: 0,
		},

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
			alignItems: 'start',
			[`&> div:last-child`]: {
				borderLeft: theme.divider.border,
				paddingLeft: theme.spacing.large,
				borderTop: 'none',
				paddingTop: 0,
				marginTop: theme.spacing.small,
			},
			[`&> div:not(:last-child)`]: {
				paddingRight: theme.spacing.large,
			},
		},
	},
}));
